import React, { useEffect, useState } from "react";
import { isMacOs, isWindows, isMobile } from "react-device-detect";

interface SwitcherProps {
  mac: string;
  windows: string;
  other: string;
}

const OsSwitcher: React.FC<SwitcherProps> = ({
  mac,
  windows,
  other: fallbackContent,
}) => {
  const [content, setContent] = useState(fallbackContent);

  useEffect(() => {
    if (!isMobile) {
      if (isMacOs) {
        setContent(mac);
      } else if (isWindows) {
        setContent(windows);
      }
    }
  }, [mac, windows]);

  return <div dangerouslySetInnerHTML={{ __html: content }} />;
};

export default OsSwitcher;
